(function () {

    document.addEventListener("DOMContentLoaded", (event) => {
        //console.log('loaded')
        const isAccordion = document.querySelectorAll(".is-accordion");
        const isAccordionTitle = document.querySelectorAll(".accordion-title");
        const isAccordionContent = document.querySelectorAll(".accordion-content");

        Array.prototype.forEach.call(isAccordionTitle, function (el, i) {

            isAccordionTitle[i].addEventListener("click", () => {
                //console.log('clicked')
                //isAccordionContent.style.display = "block";
                if (isAccordionContent[i].classList.contains('hidden')) {
                    isAccordionContent[i].classList.remove('hidden');
                } else {
                    isAccordionContent[i].classList.toggle('hidden');
                }
                if (isAccordion[i].classList.contains('is-accordion-active')) {
                    isAccordion[i].classList.remove('is-accordion-active');
                } else {
                    isAccordion[i].classList.toggle('is-accordion-active');
                }
            }); //end click
        }); //end forEach
    }); //end doc load
})(); //calls function

//trigger a change to js